import { defineMessage } from 'services/localization';

export const messages = {
    bubbleText: defineMessage('pulling_from_xero'),
    learnMore: defineMessage('learn_more'),
    externalSubmitterRequiredValidationText: defineMessage('please_select_a_requester'),
    chooseRequester: defineMessage('choose_a_requester'),
};
